import React, { useState } from 'react';
import './App.css';
import imagePath from './images/img.png';
import html2canvas from 'html2canvas';

const App = () => {
  const [layer1Src, setLayer1Src] = useState(imagePath);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLayer1Src(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleScreenshot = () => {
    const container = document.querySelector('.image-container');
    html2canvas(container).then(canvas => {
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = 'wallpaper.png';
      link.click();
    });
  };

  return (
    <div>
      {/* <h2>ipad Wallpaper Preview</h2> */}
      <div className="controls">
        <input type="file" accept="image/*" onChange={handleImageChange} className='input-file' />
        <button onClick={handleScreenshot}>Screenshot</button>
      </div>
      <br/>
      <div className="image-container">
        <img src={layer1Src} alt="Layer 1" className="layer layer1" />
        <img src={require('./images/myIpadBack.png')} alt="Layer 2" className="layer layer2" />
      </div>
    </div>  
  );
}

export default App;